import React, { useEffect } from 'react';
import { JRCButton, JRCButtonProps } from '../JRCButton/JRCButton';
import { FormattedMessage } from 'react-intl';

/**
 * Interface to provide JRCMenu props
 * @member multiple tell if you upload one or multiple files
 * @member getContent get content of uploaded files
 */
export interface JRCButtonFileProps extends JRCButtonProps {
    multiple?: boolean;
    getContent: (file: Array<string | ArrayBuffer>) => void;
}

/**
 *
 * @param iconName icon name
 * @param {label, action?, color?, variant?} props, @see JRCButtonDropdownProps
 * @returns JSX.Element
 */
export const JRCButtonFile = ({ icon = 'icon-file-o', multiple = false, getContent, ...props }: JRCButtonFileProps) => {
    const [files, setFiles] = React.useState<Array<string | ArrayBuffer>>([]);
    const inputRef = React.useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (files.length) {
            getContent(files);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);

    const inputHandleClick = () => {
        inputRef?.current?.click();
    };

    const fileHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event?.target?.files) {
            const multiFiles: Array<string | ArrayBuffer> = [];
            for (let i = 0; i < event.target.files.length; i++) {
                const reader = new FileReader();
                reader.readAsText(event.target.files[i]);
                reader.onload = () => {
                    if (reader.result) {
                        multiFiles.push(reader.result);
                        setFiles(multiFiles);
                    }
                };
            }
        }
    };

    return (
        <React.Fragment>
            <JRCButton onClick={inputHandleClick} icon={icon} {...props}>
                {props.children || <FormattedMessage id="GLOBAL_Import" />}
            </JRCButton>
            <input ref={inputRef} multiple={multiple} onChange={fileHandler} type="file" hidden />
        </React.Fragment>
    );
};
